import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Ponerle nombre: “Me hago pequeño/a para que no me dejen”",
    opening: localizedGenderNode(
      [
      "Hoy dejo de culparme. Reconozco un patrón: me hago más pequeño/a para poder quedarme."
    ],
      [
      "Hoy dejo de culparme. Reconozco un patrón: me hago más pequeño/a para poder quedarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Este miedo intenta protegerme, no controlarme.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Este miedo intenta protegerme, no controlarme.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Me pregunto:\n¿Qué hago para estar “bien” ante los ojos de mi pareja?\n[Escribe aquí]",
      "Me pregunto:\n¿En qué no me permito ser yo?\n[Escribe aquí]",
      "Me pregunto:\n¿Qué me dice el miedo que pasará si soy auténtico/a?\n[Escribe aquí]"
    ],
      [
      "Me pregunto:\n¿Qué hago para estar “bien” ante los ojos de mi pareja?\n[Escribe aquí]",
      "Me pregunto:\n¿En qué no me permito ser yo?\n[Escribe aquí]",
      "Me pregunto:\n¿Qué me dice el miedo que pasará si soy auténtico/a?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Hoy veo el patrón — sin pelearme con él."
    ],
      [
      "Cierre",
      "Hoy veo el patrón — sin pelearme con él."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: una respiración + la frase en mi corazón: “Puedo ser yo, aunque sea un poco.”",
      "Una vez hoy: una respiración + la frase en mi corazón: “Puedo ser yo, aunque sea un poco.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Historia vs. hecho: ¿Cuál es el peligro real?",
    opening: localizedGenderNode(
      [
      "Hoy separo un miedo antiguo de lo que está pasando ahora."
    ],
      [
      "Hoy separo un miedo antiguo de lo que está pasando ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “No todo miedo es un hecho.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “No todo miedo es un hecho.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el hecho simple? (lo que realmente pasó, sin interpretación)\n[Escribe aquí]",
      "¿Qué historia cuenta mi mente? (“Si digo…, me dejarán”)\n[Escribe aquí]",
      "¿Qué le hace a mi cuerpo cuando creo esa historia?\n[Escribe aquí]",
      "¿Qué verdad suave puedo elegir hoy?\n[Escribe aquí]"
    ],
      [
      "¿Cuál es el hecho simple? (lo que realmente pasó, sin interpretación)\n[Escribe aquí]",
      "¿Qué historia cuenta mi mente? (“Si digo…, me dejarán”)\n[Escribe aquí]",
      "¿Qué le hace a mi cuerpo cuando creo esa historia?\n[Escribe aquí]",
      "¿Qué verdad suave puedo elegir hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No todo pensamiento es verdad. A veces es solo miedo pidiendo seguridad."
    ],
      [
      "Cierre",
      "No todo pensamiento es verdad. A veces es solo miedo pidiendo seguridad."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Eso es una historia, no un hecho.” + una respiración.",
      "Una vez hoy: “Eso es una historia, no un hecho.” + una respiración."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El impulso de complacer (protocolo de 90 segundos)",
    opening: localizedGenderNode(
      [
      "Hoy construyo una pausa antes de “complacer”."
    ],
      [
      "Hoy construyo una pausa antes de “complacer”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Me elijo a mí primero.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Me elijo a mí primero.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde complazco más? (silencio / acuerdo / disculpas / ceder)\n[Escribe aquí]",
      "¿Qué intento evitar al complacer? (enojo / abandono / crítica / distancia)\n[Escribe aquí]",
      "Protocolo de 90 segundos (desde hoy, fijo)\n\n1. 3 respiraciones lentas\n\n2. Notar el cuerpo: ¿dónde se asienta el miedo?\n\n3. Frase en mi corazón: “Esto es miedo. Pasará.”\nY luego elijo una alternativa pequeña.\n\n\n¿Qué alternativa elijo hoy en lugar de complacer?\n[Escribe aquí]"
    ],
      [
      "¿Dónde complazco más? (silencio / acuerdo / disculpas / ceder)\n[Escribe aquí]",
      "¿Qué intento evitar al complacer? (enojo / abandono / crítica / distancia)\n[Escribe aquí]",
      "Protocolo de 90 segundos (desde hoy, fijo)\n\n1. 3 respiraciones lentas\n\n2. Notar el cuerpo: ¿dónde se asienta el miedo?\n\n3. Frase en mi corazón: “Esto es miedo. Pasará.”\nY luego elijo una alternativa pequeña.\n\n\n¿Qué alternativa elijo hoy en lugar de complacer?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que complacer para ser amado/a."
    ],
      [
      "Cierre",
      "No tengo que complacer para ser amado/a."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — protocolo de 90 segundos antes de un “sí” automático.",
      "Una vez hoy — protocolo de 90 segundos antes de un “sí” automático."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Dónde desaparezco en la relación",
    opening: localizedGenderNode(
      [
      "Hoy veo dónde me entrego para mantener la relación."
    ],
      [
      "Hoy veo dónde me entrego para mantener la relación."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Mi vida no está hecha para encogerse para estar juntos.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Mi vida no está hecha para encogerse para estar juntos.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde siento que estoy “condicional”?\n[Escribe aquí]",
      "¿Qué parte de mí escondo? (deseo / dolor / opinión / límite)\n[Escribe aquí]",
      "¿Qué precio pago por esconderme?\n[Escribe aquí]"
    ],
      [
      "¿Dónde siento que estoy “condicional”?\n[Escribe aquí]",
      "¿Qué parte de mí escondo? (deseo / dolor / opinión / límite)\n[Escribe aquí]",
      "¿Qué precio pago por esconderme?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Si desaparezco — la relación no me está sosteniendo de verdad."
    ],
      [
      "Cierre",
      "Si desaparezco — la relación no me está sosteniendo de verdad."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una frase de verdad sobre mí — solo para mí.",
      "Escribo una frase de verdad sobre mí — solo para mí."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Vergüenza: “Si me ven, no me van a querer”",
    opening: localizedGenderNode(
      [
      "Hoy toco la vergüenza sin dejar que me controle."
    ],
      [
      "Hoy toco la vergüenza sin dejar que me controle."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “La vergüenza quiere que me esconda. Hoy me quedo.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “La vergüenza quiere que me esconda. Hoy me quedo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es la frase más dura que me digo sobre mí?\n[Escribe aquí]",
      "Si un amigo querido dijera eso de sí mismo — ¿qué le diría yo?\n[Escribe aquí]",
      "¿Cuál es una frase suave que estoy dispuesto/a a decirme hoy?\n[Escribe aquí]"
    ],
      [
      "¿Cuál es la frase más dura que me digo sobre mí?\n[Escribe aquí]",
      "Si un amigo querido dijera eso de sí mismo — ¿qué le diría yo?\n[Escribe aquí]",
      "¿Cuál es una frase suave que estoy dispuesto/a a decirme hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La vergüenza no dice la verdad. Dice que me duele ser visto/a."
    ],
      [
      "Cierre",
      "La vergüenza no dice la verdad. Dice que me duele ser visto/a."
    ]
    ),
    action: localizedGenderNode(
      "Mano en pecho/vientre (si se siente bien) + una sola frase suave.",
      "Mano en pecho/vientre (si se siente bien) + una sola frase suave."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "De dónde viene (una raíz suave)",
    opening: localizedGenderNode(
      [
      "Hoy entiendo: el miedo no empezó en esta relación."
    ],
      [
      "Hoy entiendo: el miedo no empezó en esta relación."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Es un patrón antiguo activándose ahora.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Es un patrón antiguo activándose ahora.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo en mi vida aprendí que ser yo era peligroso?\n[Escribe aquí]",
      "¿Qué necesitaba entonces y no recibí?\n[Escribe aquí]",
      "¿Qué necesito hoy para sentirme lo suficientemente seguro/a como para mostrarme?\n[Escribe aquí]"
    ],
      [
      "¿Cuándo en mi vida aprendí que ser yo era peligroso?\n[Escribe aquí]",
      "¿Qué necesitaba entonces y no recibí?\n[Escribe aquí]",
      "¿Qué necesito hoy para sentirme lo suficientemente seguro/a como para mostrarme?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No es mi culpa que este miedo se formara en mí. Pero puedo cuidarlo."
    ],
      [
      "Cierre",
      "No es mi culpa que este miedo se formara en mí. Pero puedo cuidarlo."
    ]
    ),
    action: localizedGenderNode(
      "Escribo: “Hoy soy adulto/a. Puedo protegerme.”",
      "Escribo: “Hoy soy adulto/a. Puedo protegerme.”"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Una verdad pequeña (exposición limpia)",
    opening: localizedGenderNode(
      [
      "Hoy practico traer una verdad pequeña sin desbordarme."
    ],
      [
      "Hoy practico traer una verdad pequeña sin desbordarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “No todo. Solo una cosa pequeña y real.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “No todo. Solo una cosa pequeña y real.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué verdad pequeña suelo esconder?\n[Escribe aquí]",
      "¿Qué temo que pase si la digo?\n[Escribe aquí]",
      "¿Cómo puedo decirla con suavidad y claridad? (una frase)\n[Escribe aquí]"
    ],
      [
      "¿Qué verdad pequeña suelo esconder?\n[Escribe aquí]",
      "¿Qué temo que pase si la digo?\n[Escribe aquí]",
      "¿Cómo puedo decirla con suavidad y claridad? (una frase)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El coraje no es drama. El coraje es una frase."
    ],
      [
      "Cierre",
      "El coraje no es drama. El coraje es una frase."
    ]
    ),
    action: localizedGenderNode(
      "Escribo mi frase de “verdad pequeña” y practico decirla en voz alta (a solas).",
      "Escribo mi frase de “verdad pequeña” y practico decirla en voz alta (a solas)."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un límite suave (sin disculparme de más)",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite pequeño que me protege."
    ],
      [
      "Hoy pongo un límite pequeño que me protege."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Un límite es protección, no amenaza.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Un límite es protección, no amenaza.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué límite me falta en la relación?\n[Escribe aquí]",
      "¿Qué temo si lo pongo?\n[Escribe aquí]",
      "¿Cuál es una respuesta suave para ese miedo?\n[Escribe aquí]",
      "¿Cómo formulo el límite en primera persona?\n[Escribe aquí]"
    ],
      [
      "¿Qué límite me falta en la relación?\n[Escribe aquí]",
      "¿Qué temo si lo pongo?\n[Escribe aquí]",
      "¿Cuál es una respuesta suave para ese miedo?\n[Escribe aquí]",
      "¿Cómo formulo el límite en primera persona?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Quien me ama tiene que encontrarse conmigo — no con una versión reducida de mí."
    ],
      [
      "Cierre",
      "Quien me ama tiene que encontrarse conmigo — no con una versión reducida de mí."
    ]
    ),
    action: localizedGenderNode(
      "Elijo un límite pequeño para esta semana, aunque sea solo dentro de mí.",
      "Elijo un límite pequeño para esta semana, aunque sea solo dentro de mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "No pedir “permiso para existir”",
    opening: localizedGenderNode(
      [
      "Hoy dejo de esperar aprobación para sentirme legítimo/a."
    ],
      [
      "Hoy dejo de esperar aprobación para sentirme legítimo/a."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Mi existencia no necesita aprobación.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Mi existencia no necesita aprobación.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde busco aprobación básica?\n[Escribe aquí]",
      "¿Qué hago cuando no la recibo?\n[Escribe aquí]",
      "¿Qué permiso me doy hoy? (una frase)\n[Escribe aquí]"
    ],
      [
      "¿Dónde busco aprobación básica?\n[Escribe aquí]",
      "¿Qué hago cuando no la recibo?\n[Escribe aquí]",
      "¿Qué permiso me doy hoy? (una frase)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Puedo ser yo incluso cuando la respuesta no es perfecta."
    ],
      [
      "Cierre",
      "Puedo ser yo incluso cuando la respuesta no es perfecta."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: hago una cosa pequeña “para mí” sin explicarla.",
      "Una vez hoy: hago una cosa pequeña “para mí” sin explicarla."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Miedo al abandono durante el conflicto",
    opening: localizedGenderNode(
      [
      "Hoy aprendo a mantenerme estable cuando hay tensión."
    ],
      [
      "Hoy aprendo a mantenerme estable cuando hay tensión."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Un conflicto no siempre significa abandono.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Un conflicto no siempre significa abandono.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pasa en mi cuerpo cuando hay tensión?\n[Escribe aquí]",
      "¿Qué hago para calmarlo de inmediato? (complacer / cerrarme / atacar)\n[Escribe aquí]",
      "¿Qué frase de seguridad puedo decirme en medio de la tensión?\n[Escribe aquí]"
    ],
      [
      "¿Qué pasa en mi cuerpo cuando hay tensión?\n[Escribe aquí]",
      "¿Qué hago para calmarlo de inmediato? (complacer / cerrarme / atacar)\n[Escribe aquí]",
      "¿Qué frase de seguridad puedo decirme en medio de la tensión?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Puedo sostener la tensión sin desaparecer."
    ],
      [
      "Cierre",
      "Puedo sostener la tensión sin desaparecer."
    ]
    ),
    action: localizedGenderNode(
      "En una mini-tensión hoy: una respiración + mi frase de seguridad.",
      "En una mini-tensión hoy: una respiración + mi frase de seguridad."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Lo que necesito para sentirme seguro/a en una relación",
    opening: localizedGenderNode(
      [
      "Hoy reconozco mis necesidades sin vergüenza."
    ],
      [
      "Hoy reconozco mis necesidades sin vergüenza."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Una necesidad no es debilidad.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Una necesidad no es debilidad.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuáles son 3 necesidades básicas mías en una relación?\n[Escribe aquí]",
      "¿Qué necesidad me da más miedo pedir?\n[Escribe aquí]",
      "¿Cuál es una forma simple de pedirla?\n[Escribe aquí]"
    ],
      [
      "¿Cuáles son 3 necesidades básicas mías en una relación?\n[Escribe aquí]",
      "¿Qué necesidad me da más miedo pedir?\n[Escribe aquí]",
      "¿Cuál es una forma simple de pedirla?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Si no sé lo que necesito — siempre estaré “condicional”."
    ],
      [
      "Cierre",
      "Si no sé lo que necesito — siempre estaré “condicional”."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una petición corta que estoy dispuesto/a a decir (aunque aún no la diga).",
      "Escribo una petición corta que estoy dispuesto/a a decir (aunque aún no la diga)."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "“Si termina, igual me quedo conmigo”",
    opening: localizedGenderNode(
      [
      "Hoy fortalezco mi ancla interna."
    ],
      [
      "Hoy fortalezco mi ancla interna."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “No desaparezco si una relación termina.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “No desaparezco si una relación termina.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué es lo que más me asusta de que termine?\n[Escribe aquí]",
      "¿Qué recursos tengo (o puedo construir) si pasa?\n[Escribe aquí]",
      "¿Qué frase de regreso quiero para días difíciles?\n[Escribe aquí]"
    ],
      [
      "¿Qué es lo que más me asusta de que termine?\n[Escribe aquí]",
      "¿Qué recursos tengo (o puedo construir) si pasa?\n[Escribe aquí]",
      "¿Qué frase de regreso quiero para días difíciles?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Mi seguridad empieza cuando me quedo conmigo."
    ],
      [
      "Cierre",
      "Mi seguridad empieza cuando me quedo conmigo."
    ]
    ),
    action: localizedGenderNode(
      "Elijo un “ancla”: llamada con una persona segura / caminar / un pequeño orden en mi espacio.",
      "Elijo un “ancla”: llamada con una persona segura / caminar / un pequeño orden en mi espacio."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Elegir un valor guía (no un miedo guía)",
    opening: localizedGenderNode(
      [
      "Hoy dejo que un valor me guíe, no el miedo."
    ],
      [
      "Hoy dejo que un valor me guíe, no el miedo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “El miedo grita. Los valores orientan.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “El miedo grita. Los valores orientan.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor quiero traer a la relación? (honestidad / respeto / suavidad / verdad / estabilidad)\n[Escribe aquí]",
      "¿Qué cambia cuando actúo desde ese valor?\n[Escribe aquí]",
      "¿Qué acción pequeña esta semana expresa ese valor?\n[Escribe aquí]"
    ],
      [
      "¿Qué valor quiero traer a la relación? (honestidad / respeto / suavidad / verdad / estabilidad)\n[Escribe aquí]",
      "¿Qué cambia cuando actúo desde ese valor?\n[Escribe aquí]",
      "¿Qué acción pequeña esta semana expresa ese valor?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que construir una relación desde la supervivencia."
    ],
      [
      "Cierre",
      "No tengo que construir una relación desde la supervivencia."
    ]
    ),
    action: localizedGenderNode(
      "Escribo mi valor y lo pongo donde pueda verlo.",
      "Escribo mi valor y lo pongo donde pueda verlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave: una relación que no me exige desaparecer",
    opening: localizedGenderNode(
      [
      "Hoy termino este viaje sin drama — con verdad."
    ],
      [
      "Hoy termino este viaje sin drama — con verdad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración lenta. “Vuelvo a mí.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración lenta. “Vuelvo a mí.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué entendí sobre mi patrón?\n[Escribe aquí]",
      "¿Qué tengo más claro ahora, aunque duela?\n[Escribe aquí]",
      "Una frase de regreso para días de miedo al abandono (corta y clara):\n[Escribe aquí]"
    ],
      [
      "¿Qué entendí sobre mi patrón?\n[Escribe aquí]",
      "¿Qué tengo más claro ahora, aunque duela?\n[Escribe aquí]",
      "Una frase de regreso para días de miedo al abandono (corta y clara):\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No necesito una relación donde viva con condiciones.",
      "No tengo que desaparecer para ser amado/a.",
      "Sigo caminando —",
      "lento, en silencio, conmigo.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final del viaje",
      "No necesito una relación donde viva con condiciones.",
      "No tengo que desaparecer para ser amado/a.",
      "Sigo caminando —",
      "lento, en silencio, conmigo.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que simbolice “vuelvo a mí”: ordenar algo pequeño / caminar en un lugar nuevo / escribir 5 líneas en mi diario.",
      "Una acción que simbolice “vuelvo a mí”: ordenar algo pequeño / caminar en un lugar nuevo / escribir 5 líneas en mi diario."
    ),
  },
].map(buildNormalizedDay);

export const conditionalRelationshipFearOfAbandonmentBlueprintEs = buildNormalizedPilotBlueprint({
  id: "conditional_relationship_fear_of_abandonment_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "conditional_relationship_fear_of_abandonment",
  category: "general",
  journeyName: {
    he: "קשר שכל הזמן “על תנאי” (פחד שינטשו אותי אם אהיה אני)",
    en: "A Relationship That’s Always “Conditional” (Fear They’ll Leave If I’m Myself)",
    es: "Una relación siempre “condicional” (miedo a que me abandonen si soy yo)",
  },
  days,
});

export default conditionalRelationshipFearOfAbandonmentBlueprintEs;
